import { render, staticRenderFns } from "./DialogConfigurarLiderancas.vue?vue&type=template&id=1b0ec9e4&scoped=true&"
import script from "./DialogConfigurarLiderancas.vue?vue&type=script&lang=js&"
export * from "./DialogConfigurarLiderancas.vue?vue&type=script&lang=js&"
import style0 from "./DialogConfigurarLiderancas.vue?vue&type=style&index=0&id=1b0ec9e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0ec9e4",
  null
  
)

export default component.exports